import { createFileRoute } from "@tanstack/react-router";
import { PageHeader, StatusPill } from "@/components/shared/Primitives";
import { CalendarCheck2, MapPin, Plus, Wrench } from "lucide-react";

export const Route = createFileRoute("/portal/bookings")({
  component: Bookings,
});

const bookings = [
  {
    id: "BK-7821",
    title: "Ceiling Fan Installation",
    date: "Tue, May 12 · 10:00 AM",
    tech: "Priya Sharma",
    addr: "Bandra West, Mumbai",
    status: "assigned",
  },
  {
    id: "BK-7822",
    title: "Annual Maintenance — Ceiling Fan",
    date: "Thu, May 14 · 3:30 PM",
    tech: "Manish Kumar",
    addr: "Andheri East, Mumbai",
    status: "en_route",
  },
  {
    id: "BK-7811",
    title: "Ceiling Fan Repair",
    date: "Sat, May 09 · 11:00 AM",
    tech: "Rahul Verma",
    addr: "Powai, Mumbai",
    status: "completed",
    csat: 5,
  },
];

function Bookings() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Service bookings"
        description="Schedule installations, repairs, and maintenance visits."
        actions={
          <button className="inline-flex h-9 items-center gap-1.5 rounded-lg bg-gradient-primary px-3 text-xs font-medium text-primary-foreground shadow-glow">
            <Plus className="h-3.5 w-3.5" /> Book a visit
          </button>
        }
      />
      <div className="grid gap-4 md:grid-cols-2">
        {bookings.map((b) => (
          <div
            key={b.id}
            className="rounded-2xl border border-border bg-card p-5 shadow-elegant"
          >
            <div className="flex items-center gap-3">
              <div className="grid h-11 w-11 place-items-center rounded-xl bg-gradient-primary/10 text-primary">
                <Wrench className="h-5 w-5" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold">{b.title}</div>
                <div className="text-xs text-muted-foreground">{b.id}</div>
              </div>
              <StatusPill value={b.status} />
            </div>
            <div className="mt-4 space-y-1.5 text-xs text-muted-foreground">
              <div className="flex items-center gap-2">
                <CalendarCheck2 className="h-3.5 w-3.5" />
                {b.date}
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="h-3.5 w-3.5" />
                {b.addr}
              </div>
              <div className="flex items-center gap-2">
                <Wrench className="h-3.5 w-3.5" />
                Technician: {b.tech}
              </div>
            </div>
            <div className="mt-4 flex gap-2">
              <button className="h-8 flex-1 rounded-lg border border-border text-xs hover:bg-muted">
                Reschedule
              </button>
              <button className="h-8 flex-1 rounded-lg bg-gradient-primary text-xs font-medium text-primary-foreground">
                Track technician
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
